import React, {FC} from 'react';
import {useForm} from 'react-hook-form';
import {TeacherCreateRequest, TeacherRoleNameMap} from '../../shared/types/teacher';
import {createTeacherFetch} from '../../app/axios/teacherFetches';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLFormSelect from '../../shared/components/select/HLFormSelect';
import HLButton, {HLButtonStyleType} from '../../shared/components/button/HLButton';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLModal from '../../shared/components/modal/HLModal';
import {processFormServerError} from '../../shared/utils/processFormServerError';

const roleOptions = Object.entries(TeacherRoleNameMap).map(([value, label]) => ({
    value,
    label
}));

interface CreateTeacherFormProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onSuccess: () => void;
}

const CreateTeacherModal: FC<CreateTeacherFormProps> = (
    {
        open,
        setOpen,
        onSuccess
    }) => {
    const {
        register,
        handleSubmit,
        reset,
        setError,
        watch,
        formState: {errors, isSubmitting}
    } = useForm<TeacherCreateRequest>()

    const createTeacher = async (request: TeacherCreateRequest) => {
        try {
            await createTeacherFetch(request)
            closeModal()
            onSuccess()
        } catch (err: any) {
            processFormServerError(err, setError);
        }
    };

    const closeModal = () => {
        reset()
        setOpen(false)
    }

    return (
        <HLModal open={open} onClose={closeModal} title="Создать учителя">
            <form onSubmit={handleSubmit(createTeacher)} className="columnContainer">
                <HLErrorMessage error={errors.root?.message}/>

                <HLFormInput
                    id="firstName"
                    {...register('firstName', {
                        required: 'Имя обязательно'
                    })}
                    placeholder="Имя"
                    error={errors.firstName?.message}
                />

                <HLFormInput
                    id="lastName"
                    {...register('lastName', {
                        required: 'Фамилия обязательна'
                    })}
                    placeholder="Фамилия"
                    error={errors.lastName?.message}
                />

                <HLFormInput
                    id="login"
                    {...register('login', {
                        required: 'Логин обязателен'
                    })}
                    placeholder="Логин"
                    error={errors.login?.message}
                />

                <HLFormInput
                    id="password"
                    type="password"
                    {...register('password', {
                        required: 'Пароль обязателен',
                        minLength: {value: 8, message: 'Минимум 8 символов'}
                    })}
                    placeholder="Пароль"
                    error={errors.password?.message}
                />

                <HLFormSelect
                    id="role"
                    {...register('role', {required: 'Роль обязательна'})}
                    value={watch('role') || ''}
                    options={[
                        {value: '', label: 'Роль'},
                        ...roleOptions
                    ]}
                    error={errors.role?.message}
                />

                <div className="inlineContainer">
                    <HLButton
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Создать
                    </HLButton>
                    <HLButton
                        type="button"
                        onClick={closeModal}
                        styleType={HLButtonStyleType.GRAY}
                    >
                        Отмена
                    </HLButton>
                </div>
            </form>
        </HLModal>
    );
};

export default CreateTeacherModal;